export var UIOverlayViewStatus;
(function (UIOverlayViewStatus) {
    UIOverlayViewStatus[UIOverlayViewStatus["OffAndReady"] = 0] = "OffAndReady";
    UIOverlayViewStatus[UIOverlayViewStatus["On"] = 1] = "On";
})(UIOverlayViewStatus || (UIOverlayViewStatus = {}));
